import { useContext } from "react";
import PortalContext from "../context/portalContext";

const useIsPortal = () => {
  return useContext(PortalContext);
};

export default useIsPortal;
